<script setup>

import TableRow from "@/components/global-themed/table/TableRow.vue";
import TableCell from "@/components/global-themed/table/TableCell.vue";
import useDates from "@/composables/useDates";
import AuthorityTag from "@/components/competition/partials/backlinks/AuthorityTag.vue";

defineProps({
  historicData: {
    type: Object,
    required: true,
  },
});

const dates = useDates();

</script>

<template>
  <TableRow class="tw-grid-cols-12">
    <TableCell
      class="tw-text-center"
      col-span="2"
    >
      <span>{{ dates.formattedDate(historicData.date, 'Do MMM YYYY') }}</span>
    </TableCell>
    <TableCell
      class="tw-flex tw-justify-center"
      col-span="2"
    >
      <AuthorityTag :value="historicData.domainAuthority" />
    </TableCell>
    <TableCell
      class="tw-text-center"
      col-span="2"
    >
      <div>
        {{ historicData.trustFlow }}
      </div>
    </TableCell>
    <TableCell
      class="tw-text-center"
      col-span="2"
    >
      <div>
        {{ historicData.citationFlow }}
      </div>
    </TableCell>
    <TableCell
      class="tw-text-center"
      col-span="2"
    >
      <div>
        {{ historicData.externalBacklinks }}
      </div>
    </TableCell>
    <TableCell
      class="tw-text-center"
      col-span="2"
    >
      <div>
        {{ historicData.referralDomains }}
      </div>
    </TableCell>
  </TableRow>
</template>
